import { combineReducers } from 'redux'
import { FirstReducer } from './FirstReducer'

export const CombineReducers = combineReducers({FirstReducer})